import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  Observable,
  catchError,
  forkJoin,
  map,
  switchMap,
  throwError,
} from 'rxjs';
import { Utilisateur } from '../model/userPostgres.model';
import { User } from '../model/userKeycloak.model';
import { Beneficiary } from '../model/beneficiary.model';
import { UpdatedBeneficiary } from '../model/updateBeneficiary.model';
import { Countries } from '../model/countries';
import { Cities } from '../model/cities';
import { Application } from '../model/application.model';
import { config } from '../config/api.config';
import { TestQualification } from '../model/TestQualification';
import { CandidatureRequest } from '../model/CandidatureRequest.model';
import { candidatureRequestHorsParcours } from '../model/candidatureRequestHorsParcours.model';
import { PaginatedResponse } from '../interfaces/paginateResponse.interface';
import { UnifiedApplicationDTO } from '../model/dto/UnifiedApplicationDTO';

@Injectable({
  providedIn: 'root',
})
export class BackendApiService {
  isUserLoggedIn!: boolean;

  constructor(private httpClient: HttpClient) {}

  public apiUrlToKeyCloack = config.apiBaseUrl + '/user/createUser';
  public apiUrlToPostgresDB =
    config.apiBaseUrl + '/beneficiary/createBeneficiary';
  public apiUrlForProfiles = config.apiBaseUrl + '/beneficiary/listProfile';
  public apiUrlForGender = config.apiBaseUrl + '/beneficiary/listGender';
  public apiUrlToKeyCloack2 = config.apiBaseUrl + '/user';
  public apiUrlToKeyCloack3 = config.apiBaseUrl + '/user/reset-password';
  public apiUrl = config.apiBaseUrl + '/beneficiary/listBeneficiary';
  public apiUrlForToken =
    'https://raagnale.force-n.sn/realms/FODE_Keyclaok/protocol/openid-connect/token';
  public apiUrlForLogin =
    'https://raagnale.force-n.sn/realms/FODE_Keyclaok/protocol/openid-connect/token';
  // public apigetoneBenefiuf =
  //   config.apiBaseUrl+'/beneficiary/beneficiary';
  public apigetoneBenefemail = config.apiBaseUrl + '/beneficiary/beneficiary2';
  // public apiUpdate =
  //   config.apiBaseUrl+'/beneficiary/updateBeneficiary';

  // public apiUrlToKeyCloack = 'http://localhost:8080/fodev2back/fodev2/api/user/createUser';
  // public apiUrlToPostgresDB ='http://localhost:8080/fodev2back/fodev2/api/beneficiary/createBeneficiary';
  // public apiUrlForProfiles ='http://localhost:8080/fodev2back/fodev2/api/beneficiary/listProfile';
  // public apiUrlForGender ='http://localhost:8080/fodev2back/fodev2/api/beneficiary/listGender';
  // public apiUrlToKeyCloack2 = 'http://localhost:8080/fodev2back/fodev2/api/user';
  // public apiUrlToKeyCloack3 = 'http://localhost:8080/fodev2back/fodev2/api/user/reset-password';
  // public apiUrl = 'http://localhost:8080/fodev2back/fodev2/api/beneficiary/listBeneficiary';
  // public apiUrlForToken = 'https://raagnale.force-n.sn/realms/FODE_Keyclaok/protocol/openid-connect/token';
  // public apiUrlForLogin = 'https://raagnale.force-n.sn/realms/FODE_Keyclaok/protocol/openid-connect/token';
  public apigetoneBenefiuf = config.apiBaseUrl + '/beneficiary/beneficiary';
  // public apigetoneBenefemail = 'http://localhost:8080/fodev2back/fodev2/api/beneficiary/beneficiary2';
  public apiUpdate = config.apiBaseUrl + '/beneficiary/updateBeneficiary';

  public apiUrlCountries = config.apiBaseUrl + '/countries/All';

  public apiUrlCities = config.apiBaseUrl + '/cities/All';

  public apiUrlApplications = config.apiBaseUrl + '/application/All';

  public apiCreateApplications = config.apiBaseUrl + '/application/create';

  private buildPaginationParams(
    page: number = 0,
    size: number = 10,
  ): HttpParams {
    return new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());
  }

  addApplication(applicationData: any): Observable<any> {
    return this.httpClient.post(this.apiCreateApplications, applicationData);
  }

  getApplications(): Observable<Application> {
    return this.httpClient.get<Application>(this.apiUrlApplications);
  }

  getApplicationsPaged(
    page: number = 0,
    size: number = 0,
  ): Observable<PaginatedResponse<Application>> {
    const params = this.buildPaginationParams(page, size);
    return this.httpClient.get<PaginatedResponse<Application>>(
      `${this.apiUrlApplications}/paged`,
      { params },
    );
  }

  // Méthode pour récupérer tous les appels réunis (parcours et hors parcours) avec pagination et tri
  getAllApplicationsPaged(
    page: number = 0,
    size: number = 10,
  ): Observable<PaginatedResponse<UnifiedApplicationDTO>> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());
    return this.httpClient.get<PaginatedResponse<UnifiedApplicationDTO>>(
      `${this.apiUrlApplications}/combined/paged`,
      { params },
    );
  }

  getCities(): Observable<Cities[]> {
    return this.httpClient.get<Cities[]>(this.apiUrlCities);
  }

  getCountries(): Observable<Countries[]> {
    return this.httpClient.get<Countries[]>(this.apiUrlCountries);
  }

  updateBeneficiary(
    IUF: String,
    beneficiaryToUpdate: UpdatedBeneficiary,
  ): Observable<any> {
    //// //console.log(beneficiaryToUpdate);
    //// //console.log(IUF);
    return this.httpClient.put(this.apiUpdate + `/${IUF}`, beneficiaryToUpdate);
  }

  getBeneficiaryByIUF(IUF: String): Observable<Beneficiary> {
    return this.httpClient.get<Beneficiary>(this.apigetoneBenefiuf + `/${IUF}`);
  }

  getAllProfiles(): Observable<any> {
    return this.httpClient.get<any>(this.apiUrlForProfiles);
  }

  getAllGenders(): Observable<any> {
    return this.httpClient.get<any>(this.apiUrlForGender);
  }

  sendRequestToKeyCloak(id: string): Observable<any> {
    return this.httpClient.get<any>(
      `https://dev-fode.force-n.sn/backfode/fodev2/api/user/verification-link/${id}`,
      // `http://localhost:8080/fodev2back/fodev2/api/user/verification-link/${id}`
      // `https://dev-fode.force-n.sn/backfode/fodev2/api/user/verification-link/${id}`
    );
  }

  // Fonction pour vérifier si le serveur est en ligne
  private checkServer(url: string): Observable<any> {
    return this.httpClient.get(url);
  }

  //Methode pour la creation du beneficiary
  createBeneficiary(user: User, beneficiary: Utilisateur): Observable<any> {
    // Effectuer une vérification avant d'envoyer les requêtes
    const checkKeyCloak = this.checkServer(this.apiUrlToKeyCloack);
    const checkPostgresDB = this.checkServer(this.apiUrlToPostgresDB);

    return forkJoin([checkKeyCloak, checkPostgresDB]).pipe(
      catchError((error) => {
        // Gérer les erreurs ici
        console.error('Erreur lors de la vérification des serveurs :', error);
        return throwError('Problème technique avec les serveurs.');
      }),
      // Si les serveurs sont en ligne, envoyer les requêtes
      switchMap(() => {
        const postToKeyCloak = this.httpClient.post(
          this.apiUrlToKeyCloack,
          user,
        );
        const postToPostgresDB = this.httpClient.post(
          this.apiUrlToPostgresDB,
          beneficiary,
        );
        return forkJoin([postToKeyCloak, postToPostgresDB]);
      }),
    );
    /*    return this.httpClient.get<any>(
      `http://localhost:8080/fodev2back/fodev2/api/user/verification-link/${id}`
      // `https://dev-fode.force-n.sn/backfode/fodev2/api/user/verification-link/${id}`
    ); */
  }

  //Methode pour la creation du beneficiary
  /*   createBeneficiary(user: User, beneficiary: Utilisateur): Observable<any> {
    const postToKeyCloak = this.httpClient.post(this.apiUrlToKeyCloack, user);
    const postToPostgresDB = this.httpClient.post(
      this.apiUrlToPostgresDB,
      beneficiary
    );

    return forkJoin([postToKeyCloak, postToPostgresDB]);
  } */

  //envoi de l'email de verification
  // methode de recuperation de la liste de beneficiary
  getListBeneficiary(): Observable<Beneficiary[]> {
    return this.httpClient.get<Beneficiary[]>(this.apiUrl);
  }

  public getOnebeneficiary(userName: string): Observable<any> {
    return this.httpClient.get(this.apigetoneBenefemail + '/' + userName);
  }

  public getOnebeneficiary2(id: string): Observable<any> {
    return this.httpClient.get(this.apigetoneBenefiuf + '/' + id);
  }

  public getuser(userName: string): Observable<any> {
    return this.httpClient.get(this.apiUrlToKeyCloack2 + '/' + userName).pipe(
      map((response: any) => {
        if (response) {
          return response[0].id;
        } else {
          throw new Error(
            'L\'attribut "userId" n\'est pas présent dans la réponse.',
          );
        }
      }),
    );
  }

  getApplicationById(id: number) {
    return this.httpClient.get<any>(`${config.apiBaseUrl}/application/${id}`);
  }

  updateApplication(id: number, payload: any) {
    return this.httpClient.put<any>(
      `${config.apiBaseUrl}/application/${id}`,
      payload,
    );
  }

  toggleApplication(id: number) {
    return this.httpClient.patch<any>(
      `${config.apiBaseUrl}/application/${id}/toggle`,
      {},
    );
  }

  public login(
    authToken: any,
    username: string,
    password: string,
  ): Observable<any> {
    //     Création d'un objet HttpParams pour encoder les paramètres
    const params = new HttpParams()
      .set('grant_type', 'password')
      .set('client_id', 'fk_client')
      .set('client_secret', 'VoQs23136IAFF2WM2T6G0tNJfb9nMnT0')
      .set('username', username)
      .set('password', password);

    const authHeader = new HttpHeaders({
      Authorization: `Bearer ${authToken}`,
    });

    return this.httpClient.post<any>(this.apiUrlForLogin, params, {
      headers: authHeader,
    });
  }

  public passwordreset(userId: string): Observable<any> {
    return this.httpClient.get(this.apiUrlToKeyCloack3 + '/' + userId);
  }
  private token = 'MyFakeToken';

  getTokenFromKeyCloak(): Observable<any> {
    // Création d'un objet HttpParams pour encoder les paramètres
    const params = new HttpParams()
      .set('grant_type', 'client_credentials')
      .set('client_id', 'fk_client')
      .set('client_secret', 'VoQs23136IAFF2WM2T6G0tNJfb9nMnT0');

    return this.httpClient.post<any>(this.apiUrlForToken, params);
  }

  // public updateProfil(jsonFormData : Beneficiary, iuf:string)
  // {
  //   let params = new FormData();
  //   params.append('dataJson',JSON.stringify(jsonFormData));
  //   return this.httpClient.put(this.apiUpdate+ '/' + iuf, params);
  // }

  public updateProfil(jsonFormData: Beneficiary, iuf: string) {
    const url = `${this.apiUpdate}/${iuf}`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.put(url, jsonFormData, { headers });
  }

  public getBeneficiaryByEmail(email: string | undefined): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/beneficiary/beneficiary2/` + email,
    );
  }

  public logout(): void {
    this.isUserLoggedIn = false;
    sessionStorage.removeItem('isUserLoggedIn');
    sessionStorage.removeItem('iuf');
  }

  public getAllCertificate(): Observable<any> {
    return this.httpClient.get<any>(`${config.apiBaseUrl}/certificate/liste`);
  }

  public getCurrentApplication(): Observable<any> {
    return this.httpClient.get<any>(
      `${config.openBaseUrl}/opencontroller/currentApplication`,
    );
  }

  public getApplicationByIdOpenController(id: number): Observable<any> {
    return this.httpClient.get<any>(
      `${config.openBaseUrl}/opencontroller/applicationById/${id}`,
    );
  }

  public apply(candidatureRequest: CandidatureRequest): Observable<any> {
    return this.httpClient.post<any>(
      `${config.openBaseUrl}/opencontroller/addCandidatureJotFrom
    `,
      candidatureRequest,
    );
  }
  public applyCheck(email: string, cohorte: string): Observable<any> {
    return this.httpClient.get<any>(
      `${config.openBaseUrl}/opencontroller/applyCheck/${email}/${cohorte}`,
    );
  }

  public applyCheckOneFamily(
    email: string,
    currentCohorte: string,
    previousCohorte: string[],
  ): Observable<any> {
    const params = new HttpParams()
      .set('email', email)
      .set('currentCohorte', currentCohorte)
      .set('previousCohortes', previousCohorte.join(','));

    return this.httpClient.get<any>(
      `${config.openBaseUrl}/opencontroller/applyCheck1`,
      { params },
    );
  }

  public applyCheck1Improved(
    email: string,
    currentCohorte: string,
  ): Observable<any> {
    const params = new HttpParams()
      .set('email', email)
      .set('currentCohorte', currentCohorte);

    return this.httpClient.get<any>(
      `${config.openBaseUrl}/opencontroller/applyCheck1Improved`,
      { params },
    );
  }

  public admissionCheck(email: string): Observable<any> {
    return this.httpClient.get<any>(
      `${config.openBaseUrl}/opencontroller/admissionCheck/${email}`,
    );
  }

  public getCurrentApplicationOffTrack(cohorte: string): Observable<any> {
    return this.httpClient.get<any>(
      `${config.openBaseUrl}/opencontroller/currentApplicationOffTrack/${cohorte}`,
    );
  }

  public getCurrentApplicationOffTrackByCohorte(
    cohorte: string,
    param: string,
  ): Observable<any> {
    return this.httpClient.get<any>(
      `${config.openBaseUrl}/opencontroller/currentApplicationOffTrackByCohorte/${cohorte}/${param}`,
    );
  }

  public applyOffTrack(
    candidatureRequest: candidatureRequestHorsParcours,
  ): Observable<any> {
    return this.httpClient.post<any>(
      `${config.openBaseUrl}/opencontroller/off-tracks/enrolment
    `,
      candidatureRequest,
    );
  }

  public applyCheckOffTrack(email: string, cohorte: string): Observable<any> {
    return this.httpClient.get<any>(
      `${config.openBaseUrl}/opencontroller/applyCheckOffTrack/${email}/${cohorte}`,
    );
  }

  public getCertificateByCohorte(cohorte: string): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/off-tracks/getCertificatByOffTrackCohorte/${cohorte}`,
    );
  }

  public createApplicationOffTrack(applicationData: any): Observable<any> {
    return this.httpClient.post<any>(
      `${config.apiBaseUrl}/applicationOffTrack/createApplicationOffTrack`,
      applicationData,
    );
  }

  public getListeOffTrackCohorte(): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/off-tracks/listOfftrackCohorte`,
    );
  }

  public checkIsMentor(email: string): Observable<any> {
    return this.httpClient.get<any>(
      `${config.openBaseUrl}/opencontroller/checkIsMentor/${email}`,
    );
  }
  public applyPartner(candidatureRequest: any): Observable<any> {
    return this.httpClient.post<any>(
      `${config.openBaseUrl}/opencontroller/createdPartner
    `,
      candidatureRequest,
    );
  }

  public updateApplicationOffTrack(
    id: number,
    applicationData: any,
  ): Observable<any> {
    return this.httpClient.put<any>(
      `${config.apiBaseUrl}/applicationOffTrack/updateApplicationOffTrack/${id}`,
      applicationData,
    );
  }

  public toggleApplicationLaunch(id: number): Observable<any> {
    return this.httpClient.patch<any>(
      `${config.apiBaseUrl}/applicationOffTrack/toggleApplicationLaunch/${id}`,
      null,
    );
  }
  public getApplicationOffTrackById(id: number): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/applicationOffTrack/getApplicationOffTrack/${id}`,
    );
  }
}
